<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="jps-modal"
      dialog-width="30rem"
    >
      <template #header>
        <BaseIcon name="mdi/earth" />
        公開状態の変更
      </template>
      <div class="jps-modal-content">
        <table class="jps-table">
          <tbody>
          <tr v-for="l in level">
            <td>
              <button
                class="jps-button"
                @click="change(l)"
                :disabled="publicationLevel === l"
              >
                {{ led(publicationLevelDef, l) }}
              </button>
            </td>
            <td>{{ description(l) }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.cancel) }}</button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { BaseModal } from '#components'

const { ls, lst, led } = useI18n()
const { isProject, isSysad } = useUserStore()

interface Options {
  data?: any
  levelOverride?: PublicationLevel[]
  descriptionOverride?: { [key: string]: string }
}

interface Props {
  data?: any
  levelOverride?: PublicationLevel[]
  descriptionOverride?: { [key: string]: string }
}
const props = withDefaults(defineProps<Props>(), {
})

const modal = ref<InstanceType<typeof BaseModal>>()
const _data: Ref<any> = ref()
const _levelOverride: Ref<PublicationLevel[]> = ref([])
const _descriptionOverride: Ref<{ [key: string]: string }> = ref()
const openAwait = async (options?: Options) => {
  setOptionsValue(_data, 'data', props, options)
  setOptionsValue(_levelOverride, 'levelOverride', props, options, [])
  setOptionsValue(_descriptionOverride, 'descriptionOverride', props, options)
  return await modal.value.openAwait<PublicationLevel>()
}
defineExpose({ openAwait })

const publicationLevelDef = PUBLICATION_LEVEL_DEF

const description = (p: PublicationLevel) => {
  switch (p) {
    case 'PUBLIC':
      if (_descriptionOverride.value && _descriptionOverride.value[p])
        return _descriptionOverride.value[p]
      return lst(dapLangGlobal.publicationChange.displayed, ls(dapLangGlobal.serviceName))
    case 'PROJECT':
      if (_descriptionOverride.value && _descriptionOverride.value[p])
        return _descriptionOverride.value[p]
      return lst(dapLangGlobal.publicationChange.published, ls(dapLangGlobal.serviceName))
    case 'PERMISSION':
      if (_descriptionOverride.value && _descriptionOverride.value[p])
        return _descriptionOverride.value[p]
      return '機関やプロジェクトのメンバー等、権限が与えられているユーザがログインしている場合のみ表示されます。'
  }
}

const level = computed(() => {
  if (_levelOverride.value && _levelOverride.value.length > 0)
    return _levelOverride.value
  if (isProject) {
    return ['PROJECT', 'PERMISSION']
  }
  if (isSysad) {
    return ['PUBLIC', 'PROJECT', 'PERMISSION']
  }
  return ['PUBLIC', 'PERMISSION']
})

const publicationLevel = computed(() => {
  return _data.value.permission.publicationLevel
})

const change = (pl: PublicationLevel) => {
  modal.value.resolve(pl)
}
</script>

<style lang="scss" scoped>
.jps-modal {
  .jps-button {
    width: 100%;
  }
}
</style>
